import { useId, InputHTMLAttributes, ReactNode, useState, FocusEvent } from 'react';
import DOMPurify from 'dompurify';

const Input = (
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'onBlur'> & {
    label?: string;
    srOnlyLabel?: string;
    icon?: ReactNode;
  }
) => {
  const { label, srOnlyLabel, className, icon, type = 'text', ...otherProps } = props;
  const [error, setError] = useState('');
  const htmlForId = useId();

  const onBlur = (e: FocusEvent<HTMLInputElement, Element>) => {
    const elem = e.currentTarget;
    elem.value = DOMPurify.sanitize(elem.value);
    const invalid = elem.validity.typeMismatch || elem.validity.valueMissing;
    setError(() => {
      let err = elem.validationMessage;
      if (elem.validity.patternMismatch) {
        err = elem.title;
      }
      if (invalid) err = elem.validationMessage;
      return err;
    });
  };

  return (
    <label htmlFor={htmlForId} className={`${icon && 'relative'} ${className} min-h-12`}>
      <span className={`${srOnlyLabel ? 'sr-only' : 'inline-block mb-1'} text-primary-2`}>{srOnlyLabel || label}</span>
      {icon && (
        <span aria-hidden="true" className="absolute top-10 left-3">
          {icon}
        </span>
      )}
      <input
        {...otherProps}
        id={htmlForId}
        type={type}
        onBlur={onBlur}
        className={`border rounded-lg  w-full min-h-12 ${icon ? 'pl-11 pr-4' : 'px-4'} ${
          error ? 'border-negative focus:outline-negative!' : 'border-gray-300'
        }`}
      />
      <p aria-live="polite" aria-atomic="true" className="text-negative m-0! text-xs min-h-4">
        {error}
      </p>
    </label>
  );
};

export default Input;
